module.exports = __webpack_public_path__ + "media/images/athletes/2470-86f8b31c80b61ad659d29157427c5f3f.png";